// @ts-nocheck


import { fetchRequest } from './index';

import CommonApi from './../commonApi';

const basedUrl = 'assignment';
const assignment = new CommonApi(basedUrl, 'закрепления');

export const changeStatus = async (data) =>


{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, data);
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус`);
};

export const getByContractVehiclePlan = async (
id) =>
{
  const assignment = await fetchRequest.get(
    `/${basedUrl}/getByContractVehiclePlan/${id}`
  );
  if (assignment) return assignment;
  throw new Error(`Не удалось сменить статус`);
};

export default {
  ...assignment,
  changeStatus,
  getByContractVehiclePlan
};
